import { motion } from "framer-motion";

export const Typewriter = ({ text, transition, delay }) => {
  const chars = text.split("");

  return (
    <motion.span
      style={{ display: "inline-flex" }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: delay ?? 0 }}
    >
      {chars.map((char, index) => (
        <motion.span
          key={index}
          style={{ overflow: "hidden", display: "inline-block" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: index * 0.1 + delay ?? 0 }}
        >
          {char === " " ? "\u00A0" : char}
        </motion.span>
      ))}
      <motion.span
        className="dot"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={transition}
      >
        .
      </motion.span>
    </motion.span>
  );
};
